<template lang="pug">
el-form-item.c-uploader__multi
  el-upload(
    action='/api/v2/util/uploader',
    name='files',
    :show-file-list="false",
    :on-success='handleUploadSuccess',
    :before-upload='beforeUpload')
    el-button(size='small', type='primary' icon='el-icon-plus') 画像アップロード
    .el-upload__tip(slot="tip")
      p
        | jpg/png/gif 500kb以下 : 推奨サイズ 16/9の画像 hoge
        br
        | ( 縦横比の異なる画像も登録可能ですが表示する際にデザインが崩れたり画像が見切れる場合などがあります )
  el-row(:gutter='20')
    el-col(v-for='(file, index) in form.images' :key='index' :span='12')
      .thumb__wrp(class='c-uploader__16_9')
        img(:src='file.uri')
      .func
        i.icon.el-icon-delete(@click='deleteImage(index)')
  el-button(size='small', type='success' icon='el-icon-sort' @click='showModal') 順序変更
  modal-sort-element(:visible='modalvisible' @hideModal='hideModal' :list='form.images' type='image')
</template>

<script>
import ModalSortElement from '@/components/Element/Modal/SortElement'
export default {
  name: 'ElementUploadMultiForWorks',
  data () {
    return {
      modalvisible: false
    }
  },
  props: {
    form: {
      type: Object,
      required: true
    },
    datakey: {
      type: String,
      required: true
    }
  },
  methods: {
    handleUploadSuccess (res, file) {
      const value = {
        id: res.id,
        uri: res.uri
      }
      this.form.images.push(value)
    },
    /**
     * @param {Object} file
     * @returns {undefined}
     */
    beforeUpload (file) {
      const isLt500kb = file.size / 1024 / 1024 < 0.5
      if (!/^image\/[jpeg|png|gif|webp]/.test(file.type)) {
        this.$message.error('jpg/png/gifフォーマットの画像を登録してください')
        return false
      }
      if (!isLt500kb) {
        this.$message.error('500kb以下の画像ファイルを登録してください')
        return false
      }
      return true
    },
    /**
     * @param {Number} index
     */
    deleteImage (index) {
      this.form.images.splice(index, 1)
    },
    /**
     * @param {String} key
     */
    showModal (key) {
      this.modalvisible = true
    },
    /**
     * @param {String} key
     * @param {Object} data
     */
    hideModal (key, data) {
      this.modalvisible = false
    }
  },
  components: {
    ModalSortElement
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Element/Upload/MultiForWorks/index.vue